import React from 'react';

import Chip from '@liquidweb-dev/undercurrent/Chip';
import WordPressIcon from '@liquidweb-dev/undercurrent/icons/platform/WordPress';

const WPOptimizedChip = () => (
	<Chip icon={<WordPressIcon />} label="Optimized" />
);

export default WPOptimizedChip;
